import { render } from "./LoaderComp.vue?vue&type=template&id=a70af714&scoped=true&ts=true"
import script from "./LoaderComp.vue?vue&type=script&lang=ts"
export * from "./LoaderComp.vue?vue&type=script&lang=ts"

import "./LoaderComp.vue?vue&type=style&index=0&id=a70af714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70af714"]])

export default __exports__